import { VossApplicationScopes, VossApplicationScopesText } from "../../../Constants/VOSS/vossApplicationScope";
import { VossPeriodKind, VossPeriodKindText } from "../../../Constants/VOSS/vossPeriodKind";
import { VossTimeLengthUnits, VossTimeLengthUnitsText } from "../../../Constants/VOSS/vossTimeLengthUnits";
import DateTimeInput from "../../FormComponents/Input/DateTimeInput";
import { FormInput } from "../../FormComponents/Input/Input";
import { RadioButtons } from "../../FormComponents/RadioButtons";
import { VossVersionStatus, VossVersionStatusText } from "../../../Constants/VOSS/vossVersionStatus";
import { PackageSelector } from "../../FormComponents/PackageSelector";
import { useTranslation } from "react-i18next";
import { Companies } from "../../../Constants/companies";
import { VossDiscountAutomaticApplicationKind, VossDiscountAutomaticApplicationKindText } from "../../../Constants/VOSS/vossDiscountAutomaticApplicationKind";

function DiscountInfoForm({ packages, packageActions, onChange, form: { data }, discountAgreement, chargePlanDiscounts, disableEdit }) {

    const { t } = useTranslation();

    const companyName = Companies.Spiris;

    const applicationScopes = [
        { id: 'access-type-1', label: t(VossApplicationScopesText[VossApplicationScopes.Any]), value: VossApplicationScopes.Any },
        { id: 'access-type-2', label: t(VossApplicationScopesText[VossApplicationScopes.SubscriptionCustomer]), value: VossApplicationScopes.SubscriptionCustomer },
        { id: 'access-type-3', label: t(VossApplicationScopesText[VossApplicationScopes.NonSubscriptionCustomerInvoiceRecipient]), value: VossApplicationScopes.NonSubscriptionCustomerInvoiceRecipient },
    ];

    const periodKinds = [
        { id: 'period-type-1', label: t(VossPeriodKindText[VossPeriodKind.AlignedToBindingPeriod]), value: VossPeriodKind.AlignedToBindingPeriod },
        { id: 'period-type-2', label: t(VossPeriodKindText[VossPeriodKind.AlignedToSubscriptionBillingPeriod]), value: VossPeriodKind.AlignedToSubscriptionBillingPeriod },
        { id: 'period-type-3', label: t(VossPeriodKindText[VossPeriodKind.FixedTime]), value: VossPeriodKind.FixedTime },
    ];

    const lengthUnits = [
        { id: 'length-unit-1', label: t(VossTimeLengthUnitsText[VossTimeLengthUnits.Day]), value: VossTimeLengthUnits.Day },
        { id: 'length-unit-2', label: t(VossTimeLengthUnitsText[VossTimeLengthUnits.Month]), value: VossTimeLengthUnits.Month },
        { id: 'length-unit-3', label: t(VossTimeLengthUnitsText[VossTimeLengthUnits.Year]), value: VossTimeLengthUnits.Year },
    ];

    const automaticApplicationKinds = [
        { id: 'application-kind-1', label: t(VossDiscountAutomaticApplicationKindText[VossDiscountAutomaticApplicationKind.Never]), value: VossDiscountAutomaticApplicationKind.Never },
        { id: 'application-kind-2', label: t(VossDiscountAutomaticApplicationKindText[VossDiscountAutomaticApplicationKind.ForNewPurchases]), value: VossDiscountAutomaticApplicationKind.ForNewPurchases }
    ]

    const renderStatusRadioButtons = () => {
        let statuses = [
            { id: 'status-1', label: t(VossVersionStatusText[VossVersionStatus.Draft]), value: VossVersionStatus.Draft, disabled: discountAgreement.status === VossVersionStatus.Published || discountAgreement.status === VossVersionStatus.Archived || discountAgreement.status === VossVersionStatus.Staged },
            { id: 'status-2', label: t(VossVersionStatusText[VossVersionStatus.Staged]), value: VossVersionStatus.Staged, disabled: (chargePlanDiscounts && chargePlanDiscounts.length === 0) || discountAgreement.status === VossVersionStatus.Published || discountAgreement.status === VossVersionStatus.Archived || discountAgreement.status === VossVersionStatus.Discarded },
            { id: 'status-3', label: t(VossVersionStatusText[VossVersionStatus.Published]), value: VossVersionStatus.Published, disabled: (chargePlanDiscounts && chargePlanDiscounts.length === 0) || discountAgreement.status === VossVersionStatus.Archived || discountAgreement.status === VossVersionStatus.Discarded },
            { id: 'status-4', label: t(VossVersionStatusText[VossVersionStatus.Archived]), value: VossVersionStatus.Archived, disabled: discountAgreement.status === VossVersionStatus.Draft || discountAgreement.status === VossVersionStatus.Discarded },
            { id: 'status-5', label: t(VossVersionStatusText[VossVersionStatus.Discarded]), value: VossVersionStatus.Discarded, disabled: discountAgreement.status !== VossVersionStatus.Draft },
        ];

        return <div className="form-control skynet-form-input">
            <label className="bold">{t('common.status')}</label>
            <div className="d-flex flex-column">
                <RadioButtons items={statuses} onChange={(value) => onChange(value, 'status')} value={data.status} />
            </div>
        </div>
    }

    const handlePackageChange = (selected) => {
        packageActions.getPackage(selected);
        handleFormChange(selected, 'packageId');
    };

    const handleFormChange = (value, field) => {
        onChange(value, field);
    };

    return (
        <div className="d-flex gap-64">
            <fieldset className="d-flex flex-column gap-16" style={{ width: "300px" }}>
                {packages && packages.length > 0 && <PackageSelector packages={packages} onChange={handlePackageChange} defaultPackageId={data.packageId} disabled={discountAgreement} label={t('common.package')} required={true} />}
                <FormInput label={t('common.name')} onChange={(value) => onChange(value, 'name')} required value={data.name} />
                <div className={`form-control skynet-form-input required ${disableEdit ? 'disabled' : ''}`}>
                    <label>{t('discountinfoform.validfrom')}</label>
                    <DateTimeInput dateFormat={"YYYY-MM"} showTime={false} onChange={(value) => onChange(value, 'validFrom')} value={data.validFrom} />
                </div>
                <div className={`form-control skynet-form-input ${disableEdit ? 'disabled' : ''}`}>
                    <label>{t('discountinfoform.validto')}</label>
                    <DateTimeInput dateFormat={"YYYY-MM"} showTime={false} onChange={(value) => onChange(value, 'validTo')} value={data.validTo} />
                    <em className="mb-0">{t('discountinfoform.leavempty')}</em>
                </div>
                <div>
                    <FormInput label={t('common.externalid')} onChange={(value) => onChange(value, 'externalId')} value={data.externalId} />
                    <em className="mb-0">{t('discountinfoform.relevanttosystem')}</em>
                </div>
            </fieldset>
            <fieldset className={`d-flex flex-column gap-16 ${disableEdit ? 'disabled' : ''}`}>
                <div className="form-control skynet-form-input">
                    <label className="bold">{t('discountinfoform.applicationscope', { companyName })}</label>
                    <div className="d-flex flex-column">
                        <RadioButtons items={applicationScopes} onChange={(value) => onChange(value, 'applicationScope')} value={data.applicationScope} />
                    </div>
                </div>
                <div className="form-control skynet-form-input">
                    <label className="bold">{t('discountinfoform.automaticApplicationKind')}</label>
                    <div className="d-flex flex-column">
                        <RadioButtons items={automaticApplicationKinds} onChange={(value) => onChange(value, 'automaticApplicationKind')} value={data.automaticApplicationKind} />
                    </div>
                </div>
                <div className="form-control skynet-form-input required">
                    <label className="bold">{t('discountinfoform.periodkind')}</label>
                    <div className="d-flex flex-column">
                        <RadioButtons items={periodKinds} onChange={(value) => onChange(value, 'periodKind')} value={data.periodKind} />
                    </div>
                </div>
                {data.periodKind == VossPeriodKind.FixedTime && (
                    <div className="pl-0 d-flex flex-column gap-16">
                        <div>
                            <FormInput label={t('common.amount')} required onChange={(value) => onChange(value, 'length')} value={data.length} />
                        </div>
                        <div className="d-flex flex-column">
                            <RadioButtons items={lengthUnits} onChange={(value) => onChange(value, 'unit')} value={data.unit} />
                        </div>
                    </div>
                )}
                {(data.periodKind == VossPeriodKind.AlignedToBindingPeriod || data.periodKind == VossPeriodKind.AlignedToSubscriptionBillingPeriod) && <div className="pl-0 d-flex flex-column gap-16">
                    <div>
                        <FormInput label={t('discountinfoform.perioditerationcount')} required onChange={(value) => onChange(value, 'periodIterationCount')} value={data.periodIterationCount} />
                    </div>
                </div>}
            </fieldset>
            <fieldset className="d-flex flex-column gap-16">
                {discountAgreement &&
                    renderStatusRadioButtons()
                }
            </fieldset>
        </div>
    );
}

export default DiscountInfoForm;